
function SdQuoteDetailsCtrl(TranslationService) {
    var ctrl = this;



}

SdQuoteDetailsCtrl.$inject = ['TranslationService'];

seedWebApp.component('sdQuoteDetails', {
    controller: SdQuoteDetailsCtrl,
    bindings: {
        quote: '<',
    },
    templateUrl: '/SPA/Orders/sd-quote-details.html' + seedWebApp.buildVersion
});